// extracted by css-extract-rspack-plugin
export default {"spuDetailModal":"spuDetailModal-I0lDJo","bg":"bg-Qr94rr","detailInfo":"detailInfo-fGoCJi","commodityBox":"commodityBox-YLCPK4"};